






import {Component, Prop, Vue} from "vue-property-decorator";
import ModalConfigBody from "@/components/modal/ModalConfigBody.vue";
import {IModalStep} from "@/entities";

@Component({
  components: {
    ModalConfigBody
  }
})
export default class ModalConsultationConfig extends Vue {

  @Prop() data!: IModalStep;
  @Prop() readonly subject!: any;
  @Prop() readonly updateHandler?: Function;
}
